import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { publicRoutePaths } from "@/routes/public.routes.config";
import defaultValues from '@/constant/defaultValues';
import { capitalize, find, findIndex, isEmpty, isEqual, lowerCase, map, size } from "lodash";
import Agriculture from "@/assets/images/webp/product-banner/agriculture-banner.webp";
import AutoMobile from "@/assets/images/webp/product-banner/Automobile-&-Auto-Parts.webp";
import Building from "@/assets/images/webp/product-banner/Building-Materials.webp";
import Ceramic from "@/assets/images/webp/product-banner/Ceramic.webp";
import Common from "@/assets/images/webp/product-banner/common-banner.webp";
import Cosmetic from "@/assets/images/webp/product-banner/Cosmetics-&-Personal-Care.webp";
import Electronics from "@/assets/images/webp/product-banner/Electronics-&-Gadgets.webp";
import FMCG from "@/assets/images/webp/product-banner/FMCG.webp";
import Food from "@/assets/images/webp/product-banner/Food-Products.webp";
import OilGas from "@/assets/images/webp/product-banner/Oil-&-Gas.webp";
import Pharmaceuticals from "@/assets/images/webp/product-banner/Pharmaceuticals.webp";
import Textiles from "@/assets/images/webp/product-banner/Textiles.webp";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { buildPath, showSuccessMessage } from "@/utils/common";
import { ToastContainer } from "react-toastify";
import RegistrationPopup from "@/components/RegistrationPopup";
import PopUp from "@/modules/frontend/components/PopUp";
import SupplierInqPopup from "@/modules/frontend/components/Inquiry/SupplierInqPopup";
import { useAuth } from "@/AuthProvider";
import { useDispatch } from "react-redux";
import { getProduct, favoriteProduct } from "@/store/modern/slices/productSlice";
import BookADemo from "@/modules/frontend/components/BookADemo";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import ProductCard from "@/modules/frontend/components/Market_Place/Product/ProductCard";
import companylogo from "@/images/Company-logo.svg";

import MobAgriculture from "@/assets/images/webp/market-place-banner/agriculture.webp";
import MobAutoMobile from "@/assets/images/webp/market-place-banner/automobile-&-Auto-Parts.webp";
import MobBuilding from "@/assets/images/webp/market-place-banner/building-Materials.webp";
import MobCeramic from "@/assets/images/webp/market-place-banner/ceramic.webp";
import MobCommon from "@/assets/images/webp/market-place-banner/common-banner.webp";
import MobCosmetic from "@/assets/images/webp/market-place-banner/cosmetics-&-Personal-Care.webp";
import MobElectronics from "@/assets/images/webp/market-place-banner/electronics-&-Gadgets.webp";
import MobFMCG from "@/assets/images/webp/market-place-banner/FMCG.webp";
import MobFood from "@/assets/images/webp/market-place-banner/food-Products.webp";
import MobOilGas from "@/assets/images/webp/market-place-banner/oil-&-Gas.webp";
import MobPharmaceuticals from "@/assets/images/webp/market-place-banner/pharmaceuticals.webp";
import MobTextiles from "@/assets/images/webp/market-place-banner/textiles.webp";
import unFav from "@/assets/images/png/no_favorite.png"
import { privateRoutePaths } from "@/routes/private.route.config";
import roles from "@/constant/roles.config";
import { createplanReq } from "@/store/modern/slices/requestslice";
import fav from "@/assets/images/png/favorited.png";
import placeholder from "@/assets/images/png/no_product.png";

const CATEGORY_MAP = {
  agriculture: { img: Agriculture, label: "Agriculture", category: "agriculture", mobImg: MobAgriculture },
  pharmaceuticals: { img: Pharmaceuticals, label: "Pharmaceuticals", category: "pharmaceuticals", mobImg: MobPharmaceuticals },
  ceramic: { img: Ceramic, label: "Ceramics", category: "ceramic", mobImg: MobCeramic },
  textiles: { img: Textiles, label: "Textiles", category: "textiles", mobImg: MobTextiles },
  "building-materials": { img: Building, label: "Building Materials", category: "building-materials", mobImg: MobBuilding },
  "automobile-and-auto-parts": { img: AutoMobile, label: "Automobile & Auto Parts", category: "automobile-and-auto-parts", mobImg: MobAutoMobile },
  fmcg: { img: FMCG, label: "FMCG", category: "fmcg", mobImg: MobFMCG },
  "cosmetics-and-personal-care": { img: Cosmetic, label: "Cosmetics & Personal Care", category: "cosmetics-and-personal-care", mobImg: MobCosmetic },
  "food-products": { img: Food, label: "Food Products", category: "food-products", mobImg: MobFood },
  "electronics-and-gadgets": { img: Electronics, label: "Electronics & Gadgets", category: "electronics-and-gadgets", mobImg: MobElectronics },
  "oil-gas": { img: OilGas, label: "Oil & Gas", category: "oil-gas", mobImg: MobOilGas },
  all: { img: Common, label: "All", category: "", mobImg: MobCommon },
};

function ProductCatalogue() {

  const { slug } = useParams();
  const { IMAGE_PATH } = defaultValues;

  const bkImg = useRef("");
  const mobbkImg = useRef("");

  const mainRef = useRef();
  const thumbRef = useRef();
  const productRef = useRef(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, isEndUser, isPreKYCUser, isDemoUser, isViewer, memberCompanyID } = useAuth();

  const [activeIndex, setActiveIndex] = useState("product-detail");
  const [productDetails, setProductDetails] = useState([]);
  const [similarProducts, setSimilarProducts] = useState([]);

  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [inqmodalshow, setInqModalShow] = useState(false);
  const [regmodalShow, setRegModalShow] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [showContact, setShowContact] = useState(false);
  const [registerModalShow, setRegisterModalShow] = useState(false);

   const isPaidSupplier =
    !!user &&
    user.trade_mode_type === "SUPPLIER" &&
    !!user.company_plan_name &&
    user.company_plan_name !== "Trial";


  const canSendInquiry =
    !!user && (isEndUser || user.trade_mode_type === "BUYER" || isPaidSupplier);

  const mainOptions = {
    items: 1,
    nav: false,
    dots: false,
    loop: true,
    margin: 15,
  };

  const thumbOptions = {
    items: 3,
    margin: 15,
    dots: false,
    nav: true,
    center: false,
    navText: ["", ""],
    responsive: {
      0: {
        items: 2,
      },
      400: {
        items: 2,
      },
      600: {
        items: 2,
      },
      700: {
        items: 3,
      },
      1000: {
        items: 2,
      },
      1280: {
        items: 3,
      },
      1366: {
        items: 3,
      },
      1600: {
        items: 3,
      }
    }
  };

  const options = {
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      700: {
        items: 1,
      },
      800: {
        items: 3,
      },
      1000: {
        items: 4,
      }
    },
    nav: false,
    dots: false
  }

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const favStyle = {
    height: '30px',
    width: '30px',
    marginTop: '5px',
    marginBottom: '5px'
  }

  const goToNext = () => {
    productRef.current.next();
  };

  const goToPrev = () => {
    productRef.current.prev();
  };

  const toggleItem = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const goToSlide = (index) => {
    mainRef.current.to(index, 300);
  };

  const handleRegistrationPopup = () => {
    let path = publicRoutePaths.REGISTRATION.path;
    navigate(path);
  }

  const redirectFun = (e, id) => {
    e.preventDefault();
    setRegModalShow(false);


    setTimeout(() => {
      // navigate(publicRoutePaths.REGISTRATION.path);
      window.open(publicRoutePaths.REGISTRATION.path);
    }, 100);

  };

  // const handleInqQuoteClick = (pdata) => {

  //   let sdata = { ...pdata.company };
  //   sdata.selected_product_id = pdata.id;
  //   setSelectedSupplier(sdata);
  //   if (user && (isEndUser || user.trade_mode_type === "BUYER")) {
  //     setInqModalShow(true);
  //   } else {

  //     setRegModalShow(true);
  //   }
  // }
    const handleInqQuoteClick = (pdata) => {
    let sdata = { ...pdata.company };
    sdata.selected_product_id = pdata.id;
    setSelectedSupplier(sdata);

    if (canSendInquiry) {
      // seedha inquiry modal, registration popup nahi
      setRegModalShow(false);
      setInqModalShow(true);
    } else {
      setInqModalShow(false);
      setRegModalShow(true);
    }
  }

  const handleInqClick = () => {
    setRegModalShow(false);
    setInqModalShow(true);
  }

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  const handleUpgradePlanClick = async () => {
    if (user) {
      let data = {
        member_id: user.member_id
      }
      const response = await dispatch(createplanReq(data));
      if (response) {
        if (response.type === "upgradePlan/createRequest/fulfilled") {
          setRegModalShow(false);
           if (user.trade_mode_type !== 'SUPPLIER') {
             showSuccessMessage("We have received your upgrade request. Our team will contact you soon.")
           } else {
              setTimeout(() => {
                navigate(`/${getPrefix(user)}${buildPath(privateRoutePaths.ADMIN_CHOOSE_PLAN, { id: user.member_id })}`)
            }, 500);
           }
          
        }
      }
    }
  }

  const handlefavoriteClick = async (pdata , pgName="") => {
    if(user) {
      let reqObj = {
        product_id : pdata.id
      }
      const response = await dispatch(favoriteProduct(reqObj));
      if(response && response.type === "products/favoriteProduct/fulfilled") {
        if(response.payload.status) {
          showSuccessMessage(response.payload.message); 
          if(pgName == "product-detail") {
            let p = { ...productDetails };
            if(response.payload.message === "Product removed from favorite") {
              p.isFavorite = false;
            } else {
              p.isFavorite = true;
            }
            setProductDetails(p);
            // 
          } else {
            /* const sproducts = [...similarProducts];
            if(sproducts && !isEmpty(sproducts)) {
              let p = find(sproducts, (val) => val.id === pdata.id);
              let pIndex = findIndex(sproducts, (val) => val.id === pdata.id);
              let updatedItem = p;
              if(response.payload.message == "Product removed from favorite") {
                // p.isFavorite = false;
                updatedItem = { ...p, isFavorite: false };
              } else {
                //p.isFavorite = true;
                updatedItem = { ...p, isFavorite: true };
              }
              sproducts[pIndex] = updatedItem;
              setSimilarProducts(sproducts);
            } */
          }
        }
      }
    } else {
      setRegisterModalShow(true);
    }
  }
  

  const handleRegisterBtnClick = () => {
    navigate(publicRoutePaths.REGISTRATION.path);
  }

  const stripHtml = (html) => {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent.slice(0, 150) || tmp.innerText.slice(0, 150) || "";
  }


  useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await dispatch(getProduct(slug));
        if (response) {
          if (response.payload.product) {
            setProductDetails(response.payload.product);
          } else {
            navigate(publicRoutePaths.MARKET_DETAIL.path + '?category=all');
          }

          setSimilarProducts(response.payload.other_products);
          const match = CATEGORY_MAP[response.payload.product.category.slug];

          bkImg.current = match?.img ?? "";
          mobbkImg.current = match?.mobImg ?? "";
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    if (slug) {
      fetchData();
    }
  }, [slug]);

  useEffect(() => {
    if (user) {
      if (isPreKYCUser || isEndUser) {
        if (user.trade_mode_type === "LOG_PTR") {
          setShowContact(false);
        } else if (productDetails && (user.member_id == productDetails.member_id)) {
          setShowContact(false);
        } else {
          setShowContact(true);
        }
      }
    } else {
      setShowContact(true);
    }
  }, [user, productDetails]);


   useEffect(() => {
      console.log("regmodalShow:", regmodalShow);
      console.log("user:", user);
  
      if (
          regmodalShow &&
          user?.trade_mode_type === "SUPPLIER" &&
          user?.company_plan_name !== "Trial"
      ) {
          console.log("Supplier paid user - switching modal");

          if(isPreKYCUser) {
            setInqModalShow(false);
            setRegModalShow(true);
            
          } else {
            setRegModalShow(false);
            setInqModalShow(true);
          }
  
      }
  }, [regmodalShow, user, isPreKYCUser]);

  //  useEffect(() => {
    
  //         setInterval(() => {
  //           let u = localStorage.getItem("user");
  //           u = JSON.parse(u);
  //           if(!isEqual(u, user) && user?.company_plan_name !== "Trial" && parseInt(user?.current_step) === 4) {
  //             window.location.reload();
  //           }
  //         },1500);
  //      },[user]);
  useEffect(() => {
    const intervalId = setInterval(() => {
      try {
        const stored = JSON.parse(localStorage.getItem("user"));
          console.log("Invalid user in localStorage", stored);
        if (
          stored &&
          !isEqual(stored, user) &&
          stored.company_plan_name !== "Trial" &&
          parseInt(stored.current_step) === 4
        ) {
          clearInterval(intervalId);
          window.location.reload();
        }
      } catch (e) {
        console.log("Invalid user in localStorage", e);
      }
    }, 1500);
  
    return () => clearInterval(intervalId); // cleanup
  }, [user]);
 console.log("Invalid user in localStorage", user);
  return (
    <section className="market-place-wrape product-catalogue-wrape">
      <SeoHelmet
        title={productDetails ? productDetails.product_name : seoConfig.productDetail.title}
        description={productDetails ? productDetails.product_description : seoConfig.productDetail.description}
        keywords={seoConfig.productDetail.keywords}
        author={seoConfig.productDetail.author}
      />

      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>
      {/* inner banner wrape START */}
      <div className="inner-banner ipad-hide" style={{ background: `url(${bkImg.current})` }}>
        <div className="container">
          <div className="content-wrape desk-hide">
            <h2>
              {productDetails && productDetails.category && productDetails.category.category_name}
            </h2>
          </div>
        </div>
      </div>
      {/* inner banner wrape END */}

      {/* mobile inner banner wrape START */}
      <div className="marketplace-banner mobile-banner mobile-show">
        {/* Agriculture ipad banner here */}
        <img src={mobbkImg.current} alt="" className="mob-banner" />
      </div>
      {/* mobile inner banner wrape END */}

      <div className="bradcrumb-wrape">
        <div className="container">
          <ul>
            <li>
              <Link to={publicRoutePaths.HOME.path} title="Home">Home</Link>
            </li>
            <li>
              <Link to={publicRoutePaths.MARKET_PLACE.path} title="Market Place">Market Place</Link>
            </li>
            <li>
              <Link to={`${publicRoutePaths.MARKET_DETAIL.path}?category=${productDetails && productDetails.category && productDetails.category.slug}`} title={productDetails && productDetails.category && productDetails.category.category_name}>{productDetails && productDetails.category && productDetails.category.category_name}</Link>
            </li>
            <li>
              {productDetails ? productDetails.product_name : slug}
            </li>
          </ul>
        </div>
      </div>

      <div className="inner-page-content-wrape market-place-page">
        <div className="container introduction">
          <div className="content-wrape mobile-show page-head">
            <h2 className="mobile-head-text">
              {productDetails && productDetails.category && productDetails.category.category_name}
            </h2>
          </div>
        </div>


        {/* gallery detail wrape START */}
        <div className="gallery-detail-wrape">
          <div className="container">
            <div className="row">
              <div className="col-xxl-6 col-xl-6 col-lg-6">
                <div className="product-slider">
                  <div className="main-slider">
                    {
                      size(productDetails.product_medias) > 0 ? ( 
                      <OwlCarousel ref={mainRef} className="owl-theme main-slider" {...mainOptions}>

                        {productDetails?.product_medias?.map((img, index) => (
                          <div className="item" key={index}>
                            {/* <img src={img} alt="product" className="main-image" /> */}
                            {img.photo_detail ? (
                            <img src={IMAGE_PATH.BASE_URL + img.photo_detail} alt="" />
                            ) : (
                            <img src={placeholder} alt="" />
                            )}
                          </div>
                        ))}

                      </OwlCarousel> ) : ( <div className="item default-item">
                            <img src={placeholder} alt="" />
                          </div>
                      )
                    }

                  </div>

                  <div className="thumb-slider">
                    {
                      size(productDetails.product_medias) > 0 && ( <OwlCarousel
                        ref={thumbRef}
                        className="owl-theme thumb-slider"
                        {...thumbOptions}
                      >
                        {productDetails?.product_medias?.map((img, index) => (
                          <div
                            className="item thumb-item"
                            key={index}
                            onClick={() => goToSlide(index)}
                          >
                            {img.photo_detail ? (
                              <img src={IMAGE_PATH.BASE_URL + img.photo_detail} alt="" />
                            ) : (
                              <img src={placeholder} alt="" />
                            )}
                          </div>
                        ))}
                      </OwlCarousel>
                      )
                    }

                  </div>
                </div>
              </div>
              <div className="col-xxl-6 col-xl-6 col-lg-6">
                <div className="product-details">
                  {/* <h1>Premium Turmeric Bright Golden High Curcumin Culinary Medicinal Export</h1> */}
                  <h1>{productDetails.product_name}</h1>
                  <div className="price-wrape">
                    
                    {
                      (isPreKYCUser || isEndUser) && productDetails?.company?.id != memberCompanyID && 
                      (productDetails.isFavorite ? <div style={favStyle} onClick={() => handlefavoriteClick(productDetails,"product-detail")}>
                      <img src={fav} alt='favorite' className=''/>
                    </div> : <div style={favStyle} onClick={() => handlefavoriteClick(productDetails,"product-detail")}>
                      <img src={unFav} alt='favorite' className=''/>
                    </div>)
                    }
                    {
                      !user && <div style={favStyle} onClick={() => handlefavoriteClick(productDetails,"product-detail")}>
                      <img src={unFav} alt='favorite' className=''/>
                    </div>
                    }

                    <p>Product Price</p>
                    {
                      ((productDetails && productDetails.price_type === "fixed") ? <p><b>{`$${productDetails.price} Per ${productDetails.price_unit}`}</b></p> : <p><b>Price Upon Request</b></p>)
                    }
                    
                  </div>

                  <div className="shipping-info-wrape">
                    <h4>Shipping Information</h4>
                    <div className="info-pad">
                      <div className="info">
                        <p>Trading areas</p>
                        <p><b>{productDetails?.trading_area ? productDetails.trading_area.split(",").map((item) => capitalize(item.trim())).join(", ") : "-"}</b></p>
                      </div>
                      <div className="info">
                        <p>Shipping Type</p>
                        {/* <p><b>EXW, FOB, CFR/CIF</b></p> */}
                        <b>{productDetails && size(productDetails.shipping) > 0 ? map(productDetails?.shipping, (item) => item.shipping_term).join(", ") : "-"}</b>
                      </div>
                    </div>
                  </div>

                  <div className="company-info">
                    <div className="img-wrape">
                      {/* img here */}
                      {/* <img src={productDetails?.company?.company_logo} alt="company-logo" style={{ width: '50px', height: 'auto' }} /> */}

                      <img src={productDetails && productDetails.company && productDetails.company.company_logo ? IMAGE_PATH.BASE_URL + productDetails.company.company_logo : companylogo} alt="company-logo" />
                    </div>
                    <div className="detail-pad">
                      {/* <h6>Aadhya organic herbs pvt ltd</h6> */}
                      <h6>{productDetails?.company?.company_name}</h6>
                      <div className="flag-wrape">
                        {/* <span>India</span> */}
                        {
                          productDetails && productDetails.company && productDetails.company.country && productDetails.company.country.iso3 && <img src={require(`@/assets/images/svg/flag/${lowerCase(productDetails.company.country?.iso3)}.svg`)} alt="" style={{ width: '24px', height: 'auto' }} />
                        }

                        <span>{productDetails?.company?.country?.name}</span>
                      </div>
                      {
                        productDetails && productDetails.company ? <Link
                          className="btn outline medium"
                          to={buildPath(publicRoutePaths.COMPANY_CATALOGUE, {
                            id: productDetails.company.id
                          })}
                          target="_blank"
                          href={buildPath(publicRoutePaths.COMPANY_CATALOGUE, {
                            id: productDetails.company.id
                          })}
                          title="Visit Supplier Page"
                        >
                          Visit Supplier Page
                          <span className="round">
                            <i className="sprite"></i>
                          </span>
                        </Link> : ""
                      }

                      {/* <Link className="btn outline medium red" title="Send Inquiry" to=""> */}
                      {
                        showContact && <button type="button" className="btn outline medium red" title="Send Inquiry" onClick={() => handleInqQuoteClick(productDetails)} >
                          Send Inquiry
                          <span className="round">
                            <i className="sprite"></i>
                          </span>
                        </button>
                      }

                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        {/* gallery detail wrape END */}

        {/* accordion wrape START */}
        <div className="accordion-wrape">
          <div className="container">
            <div className="row">
              <div className="col-xxl-12">
                <div className="accordion">
                   {productDetails?.product_description && 
                    <article
                      key={"product-detail"}
                      className={`accordion-item ${activeIndex === "product-detail" ? "active" : ""}`}
                    //className="accordion-item active"
                    >
                      <button
                        className="accordion-header"
                        onClick={() => toggleItem("product-detail")}
                      >
                        <div className="icon-circle">
                          {activeIndex === "product-detail" ? "−" : "+"}
                        </div>
                        <span>{`Product Details`}</span>
                      </button>

                      <div className="accordion-content">
                        {/* {activeIndex === index && <p>{item.content}</p>} */}
                        {
                          activeIndex === "product-detail" && <>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: productDetails.product_description
                              }}
                            />
                            <div className="country-section mt-4">
                              <p>Product Origin Country</p>
                              {/* <p><b>China</b></p> */}
                              <p><b>{productDetails?.origin_country?.name}</b></p>
                            </div>

                            {
                              productDetails && size(productDetails.ports) > 0 && <div className="shipping-wrape">
                                <p>Port of Shipping</p>

                                {productDetails?.ports?.map((item, index) => {
                                  return (<div className="mt-3 mb-3" key={`ship_port_${index}`}>
                                    <div className="country-list" key={index}>
                                      <div className="flag-wrape">
                                        {/* <i className="flag"></i> */}
                                        <img src={require(`@/assets/images/svg/flag/${lowerCase(item.iso3)}.svg`)} alt="" style={{ height: 24, width: 24 }} />
                                        <span>{item.name}</span>
                                      </div>
                                      <div className="list">
                                        {/* India, China */}
                                        {item.port?.map((portItem) => capitalize(portItem.name)).join(", ")}
                                      </div>
                                    </div>
                                  </div>)
                                }
                                )}
                              </div>
                            }

                          </>
                        }

                      </div>
                    </article>
                    }

                  {
                    productDetails && productDetails.about_company && <article
                      key={"about-company"}
                      className={`accordion-item ${activeIndex === "about-company" ? "active" : ""}`}
                    //className="accordion-item active"
                    >
                      <button
                        className="accordion-header"
                        onClick={() => toggleItem("about-company")}
                      >
                        <div className="icon-circle">
                          {activeIndex === "about-company" ? "−" : "+"}
                        </div>
                        <span>{`About the Supplier`}</span>
                      </button>

                      <div className="accordion-content">
                        {/* {activeIndex === index && <p>{item.content}</p>} */}
                        {
                          activeIndex === "about-company" && <>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: productDetails?.about_company
                              }}
                            />
                          </>
                        }

                      </div>
                    </article>
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
        {/* accordion wrape END */}

        {/* Trending Products START */}
        {
          size(similarProducts) > 0 && <div className="tranding-wrape">
            <div className="container">
              <div className="row">
                <div className="col-xxl-12">
                  <div className="head-text button-head">
                    <h2 className="head">More products from the supplier</h2>

                    <div className="btn-wrape">
                      {/* <Link
                        className="btn outline"
                        to="/"
                        title="View All Products"
                      >
                        View All Products
                        <span className="round">
                          <i className="sprite"></i>
                        </span>
                      </Link> */}
                      {
                        size(similarProducts) > 4 && <div className="nav-ctrl">
                          <button type="button" className="btn prev" onClick={goToPrev}>
                            <i className="sprite"></i>
                          </button>
                          <button type="button" className="btn next" onClick={goToNext}>
                            <i className="sprite"></i>
                          </button>
                        </div>
                      }

                    </div>
                  </div>
                </div>

                <div className="col-xxl-12">
                  <div className="row">
                    {
                      size(similarProducts) > 4 && <OwlCarousel className='owl-theme section' margin={20} autoplay {...options} ref={productRef} key={Date.now()}>
                        {
                          map(similarProducts, (val, k) => {
                            return (<div className="review item" key={`sp_${k}`}><ProductCard favKey={`fav_product_${val.id + '_'+ Date.now()}`} data={val} showDesc={false} showContact={showContact} showPrice={true} handleQuoteClick={handleInqQuoteClick} handlefavoriteClick={handlefavoriteClick} /></div>)
                          })
                        }
                      </OwlCarousel>

                    }

                    {
                      size(similarProducts) <= 4 &&

                      map(similarProducts, (val, k) => {
                        return (<div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6" key={`sp_${k}`}><ProductCard favKey={`fav_product_${val.id + '_'+ Date.now()}`} data={val} showDesc={false} showContact={showContact} showPrice={true} handleQuoteClick={handleInqQuoteClick} handlefavoriteClick={handlefavoriteClick} /></div>)
                      })



                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }

        {/* Trending Products END */}
      </div>

      <ConsentManager />


      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}

      {
        inqmodalshow && (
          <PopUp
            title="Business Inquiry"
            smallmodalShow={inqmodalshow}
            setSmallModalShow={setInqModalShow}
            className="book-demo"
            size="lg"
          >
            <SupplierInqPopup data={selectedSupplier} setInqModalShow={setInqModalShow} from={!user ? "continue_buyer" : ""} />
          </PopUp>
        )
      }

      {
        regmodalShow && <RegistrationPopup
          title=""
          smallmodalShow={regmodalShow}
          setSmallModalShow={setRegModalShow}
          onSubmit={handleRegistrationPopup}
          okButtonLabel={'REGISTER NOW'
          }
        >
          {(() => {
            if (user && isPreKYCUser) {
              return (
                <div className="new-pop">
                  <div className="img-wrape"></div>
                  <div className="detail-wrape">
                    <div className="inner">
                      <h5 className="registor-now">Grow With Us!</h5>
                      <h6>Upgrade now to get more benefits!</h6>
                      <p className="registor-now-text">
                        Access special features, get personalized recommendations and connect with a growing community.
                      </p>
                      {/* <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`} className="btn secondry-btn" onClick={(e) => {
                        redirectFun(e, user.member_id)
                      }}>
                        Go to Profile
                      </Link> */}
                      <button type="button" className="btn secondry-btn" onClick={handleUpgradePlanClick}>
                        Upgrade Plan
                      </button>
                    </div>
                  </div>
                </div>
              );
            } else {
              return (<div className="new-pop">
                <div className="img-wrape"></div>
                <div className="detail-wrape">
                  <div className="inner">
                    <h5 className="registor-now">Grow With Us!</h5>
                    <p>
                      Select your role to get started:
                    </p>
                    <Link
                      to={publicRoutePaths.REGISTRATION.path}
                      className="popup-category-btn"
                      onClick={(e) => {
                        redirectFun(e, null)
                      }}
                    >
                      <span className="icon supplier"></span>
                      <span className="detail">
                        <h3>Supplier</h3>
                        <p>Sell and showcase your products</p>
                      </span>
                      {/* <p>
                        <span>Sell and showcase your products</span>
                      </p>Supplier */}

                    </Link>
                    <Link
                      to={publicRoutePaths.REGISTRATION.path}
                      className="popup-category-btn"
                      onClick={(e) => {
                        redirectFun(e, null)
                      }}
                    >
                      <span className="icon logistics"></span>
                      <span className="detail">
                        <h3>Logistic Partner</h3>
                        <p>Scaling Your Growth Through Reliable Logistics</p>
                      </span>

                    </Link>
                    <button type="button" className="popup-category-btn" onClick={handleInqClick}>
                      <span className="icon buyer"></span>
                      <span className="detail">
                        <h3>Buyer</h3>
                        <p>Discover and connect with suppliers</p>
                      </span>
                      {/* Buyer
                      <p>
                        <span>Discover and connect with suppliers</span>
                      </p> */}
                    </button>

                  </div>
                </div>
              </div>
              );
            }
          })()}

        </RegistrationPopup>
      }
      <ToastContainer />

      {
        registerModalShow && <RegistrationPopup
        title=""
        smallmodalShow={registerModalShow}
        setSmallModalShow={setRegisterModalShow}
        onSubmit={handleRegisterBtnClick}
        okButtonLabel="REGISTER NOW"
      >
        <div className="new-pop">
          <div className="img-wrape"></div>
          <div className="detail-wrape">
            <div className="inner">
              <h5 className="registor-now">Grow With Us!</h5>
              <h6>Register now to get more benefits!</h6>
              <p className="registor-now-text">
                Access special features, get personalized recommendations and connect with a growing community.
              </p>
              <Link to={publicRoutePaths.REGISTRATION.path} className="btn secondry-btn" target="_blank" href={publicRoutePaths.REGISTRATION.path} >Register Now</Link>
            </div>
          </div>
        </div>
      </RegistrationPopup>
      }

    </section>
  )
}

export default ProductCatalogue
